/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { getAllApiToken, addApiToken, deleteApiToken, activatedeactivate } from 'src/services/apiTokenService';
import { Grid, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
// import MUIModal from '../MUIModal/MUIModal';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_API, DELETE_API_SUCCESS_MESSAGE, ACTIVATE_API_SUCCESS_MESSAGE, DEACTIVATE_API_SUCCESS_MESSAGE  } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState, ApiTokenResponse } from '../types/types';
import moment from 'moment';
//@ts-ignore
import {Copy01StrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip,  {tooltipClasses } from '@mui/material/Tooltip';
import {checkEventPermission} from "../../common/utility/utility";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
  ))(({ theme }) => ({
      [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.common.white,
      },
      [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.black,
      },
  }));

const ITEM_HEIGHT = 48;

interface ApiTokenListPropType {
  "id": number;
  "clientId": number;
  "tokenName": string;
  "accessToken": string;
  "isActive": boolean;
  "createdBy": number;
  "createdUser": string;
  "createdOn": string;
  "updatedBy": number;
  "updatedOn": string;
  "updatedUser": string;
  "lastUsedOn": string;
}

interface ApiResponse {
  status: number;
  data: {
    data: ApiTokenListPropType[];
    result: number;
  };
}

// interface PropsType {
//   closeModal: () => void;
//   refreshPage: () => void;
// }

const ApiTokenList: React.FC = () => {

  const [apiTokenListData, setApiTokenListData] = useState<ApiTokenListPropType[]>([])
  const [apiTokenSearchData, setApiTokenSearchData] = useState<ApiTokenListPropType[]>([])
  // const [openAddApiTokenModal, setOpenAddApiTokenModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [apiTokenInfoData, setApiTokennfoData] = useState<any>();
  const [showAddApiModal, setAddApiModal] = useState<boolean>(false);
  const [showDeleteApiTokenModal, setDeleteApiTokenModal] = useState<boolean>(false);
  const [showDeactivateApiModal, setDeactivateApiModal] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);
  const [tokenName, setTokenName] = useState('');
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getapiTokenListData()
  }, [user])

  const getapiTokenListData = (): void => {
    setLoading(true)
    const ClientId = user?.clientId ?? 0;
    getAllApiToken(ClientId)
    .then(
      (res: ApiResponse) => {
        if (res.status === 200) {
          if(res.data.result === 1) {
          const apiArr: ApiTokenListPropType[] = [];
          res.data.data.map((api: any) => {
            api.Name = `${api.clientName}`
            apiArr.push(api)
          })
          setApiTokenListData(apiArr)
          setApiTokenSearchData(apiArr)
        } else {
          setApiTokenListData([])
          setApiTokenSearchData([])
        }
        }
      }
    ) 
    .catch (
      (      error: any) => console.log("Error: ", error)
    )
    .finally(() => {
      setLoading(false)
    })
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let apiTokenDataArr = [...apiTokenListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      apiTokenDataArr = apiTokenDataArr && apiTokenDataArr.filter((apiToken: ApiTokenListPropType) => {
        return apiToken.tokenName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setApiTokenSearchData(apiTokenDataArr)
  }

  const handleAddApiToken = (clientId: number, tokenName: string, createdBy: number): void => {
    setApiTokennfoData({ clientId, tokenName, createdBy });
    setAddApiModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [clientId]: null });
  }

  const handleAddApiTokenClose = ():void => {
    setTokenName(''); // Clear the token name
    setValidationError(''); // Clear the validation error
    setAddApiModal(false);
  }
  
  const handleAddApiTokenConfirm =  (): void => {
  const spaceRegex = /^\s|\s$|\s{2,}/; // Matches space at start (^) or end ($)

  // Check if token name is empty or has leading/trailing spaces
  if (spaceRegex.test(tokenName)) {
    setValidationError("Please enter a valid API Key name");
    return;
  }
  // Check if the token name is empty after removing spaces
  if (tokenName.length === 0) {
    setValidationError("Please enter a valid API Key name");
    return;
  }

  // Clear validation error if input is valid
  setValidationError("");

  setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  const userData = JSON.parse(localStorage.getItem("user"))
  const data = { clientId: userData?.clientId ?? 0, createdBy: userData?.id ?? 0, tokenName: tokenName}
  setLoading(true)
  addApiToken(data)
      .then(
          (res: ApiTokenResponse) => {
              console.log(res)
              if(res.status === 200) {
                  if(res.data.result === 1) {
                      NotificationManager.success("API Key added successfully")
                      setTokenName('');
                      handleAddApiTokenClose();
                      getapiTokenListData();
                  } else {
                    const errorMsg: string = res.data.messages || "Unknown error occurred";
                    NotificationManager.error(errorMsg.includes("API Key Name already exists in the system")? "API Key name already exists": errorMsg,"",5000);
                  }
              }
          }
      )
      .catch(
          error => {
              console.log("error", error)
              NotificationManager.error("Unknown error has occurred")
          }
      )
      .finally(() => {
          setIsModalSaveLoading(false);
          setLoading(false)
      })
  }

  const handleDeleteApiToken = (id: number, apiTokenName: string): void => {
      setApiTokennfoData({ id, apiTokenName });
      setDeleteApiTokenModal(true)
      setAnchorActionEl(null);
      setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }
  
    const handleDeleteApiTokenClose = ():void => {
      setDeleteApiTokenModal(false)
    }
  
    const handleDeleteApiTokenConfirm = ():void => {
      setIsModalSaveLoading(true)
  
    const { id } = apiTokenInfoData;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
      deleteApiToken(id,userData.id,)
        .then(
          (res: ApiResponse) => {
            if(res.status === 200) {
              if(res.data.result === 1) {
                NotificationManager.success(DELETE_API_SUCCESS_MESSAGE, '', 5000);
                setDeleteApiTokenModal(false)
                getapiTokenListData()
              }
            }
          }
        )
        .catch((error: any) => console.log("Error", error))
        .finally(() => setIsModalSaveLoading(false))
    }

  const handleactivatedeactivate = (id: number, isActive: boolean, clientName: string): void => {
    const newIsActive = !isActive;
    setApiTokennfoData({ id, isActive: newIsActive, clientName });
    setDeactivateApiModal(true)
    setAnchorActionEl(null);
    setAnchorActionEl({ ...anchorActionEl, [id]: null });
  }

  const handleactivatedeactivateClose = ():void => {
      setDeactivateApiModal(false)
  }
  
  const handleActivateDeactivateConfirm = ():void => {

    setIsModalSaveLoading(true)

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
    const { id, isActive } = apiTokenInfoData;

    activatedeactivate(id,(Boolean((apiTokenInfoData?.isActive))) ? 1 : 0,userData.id )
      .then(
        (res: ApiResponse) => {
          if(res.status === 200) {
            if(res.data.result === 1) {
              if (Boolean(isActive)) {
                NotificationManager.success(ACTIVATE_API_SUCCESS_MESSAGE, '', 5000);
              } else {
                NotificationManager.success(DEACTIVATE_API_SUCCESS_MESSAGE, '', 5000);
                // Adjust the width inline
                setTimeout(() => {
                  const notification = document.querySelector('.notification-container') as HTMLElement | null;
                  if (notification !== null) {
                    notification.style.width = '340px'; // Set your desired width
                  }
                }, 0);
              }
              setDeactivateApiModal(false)
              getapiTokenListData()
            }
          }
        }
      )
      .catch((error: any) => console.log("Error", error))
      .finally(() => setIsModalSaveLoading(false))
  }

  const columns: TableColumn<ApiTokenListPropType>[] = [
    {
      name: 'Name',
      selector: (row: ApiTokenListPropType) => row.tokenName,
      cell: (row: ApiTokenListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.tokenName}</p>
            </div>
          </div>
        )
      },
      width: '15%',
      sortable: true
    },
    {
      name: "API Key",
      selector: (row: ApiTokenListPropType) => row.accessToken,
      width: "35%",
      sortable: true,
      cell: (row: ApiTokenListPropType) => {
        const [tooltipText, setTooltipText] = useState("Copy API Key");

        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const handleCopyToken = (token: string) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          navigator.clipboard.writeText(token);
          setTooltipText("Copied!"); // Change tooltip to "Copied!"
          setTimeout(() => setTooltipText("Copy API Key"), 1500); // Reset after 1.5s
        };
  
        return (
          <div className="flex items-center">
            <span className="truncate" style={{ maxWidth: "250px" }}>
              {row.accessToken}
            </span>
            <BootstrapTooltip title={tooltipText} arrow>
              <IconButton
                onClick={() => handleCopyToken(row.accessToken)}
                size="small"
                sx={{ marginLeft: "10px" }}
              >
                
                <HugeiconsIcon
                icon={Copy01StrokeStandard}
                size={20}
                color="currentcolor"
                /> 

              </IconButton>
            </BootstrapTooltip>
          </div>
        );
      },
    },
    {
      name: 'Created On',
      selector: (row: ApiTokenListPropType) => moment(row.createdOn).format('MM/DD/YYYY'),
      width: '15%',
      sortable: true
    },  
    {
      name: 'Last Used',
      selector: (row: ApiTokenListPropType) => row.lastUsedOn ? moment(row.lastUsedOn).format('MM/DD/YYYY') : 'Not used',
      width: '15%',
      sortable: true
    },
    {
      name: 'Status',
      sortable: false,
      width: "10%",
      // selector: row => row.year,
      cell: (row: ApiTokenListPropType) => {
        return row.isActive ? <div className="badge truncate" style={{
          background: '#CCFFEA',
          padding: '10px 15px',
          color: '#06A864',
          border: '0px'
        }}>Active</div> : <div className="badge truncate" style={{
          background: '#FFF5F6',
          padding: '10px 15px',
          color: '#F13139',
          border: '0px'
        }}>Inactive</div>
      },
      center: true,
    },
    {
      name: 'Actions',
      // selector: (row: any) => row.role,
      cell: (row: ApiTokenListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            {/* <div onClick={() => handleEditWebhookClick(row.id)} style={{ width: '20px', cursor: 'pointer' }}>
              <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="Edit Webhook" />
            </div> */}
            {(checkEventPermission("API_TOKEN_ACTIVATE") || checkEventPermission("API_TOKEN_DELETE") ) &&
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                <HugeiconsIcon
              icon={MoreVerticalSolidRounded}
              size={24}
              color="#3A3A3A"
              strokeWidth={0.2}
            />
              </IconButton>
              <Menu
                id={`${row.id}`}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                slotProps={{ paper: {
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '16ch',
                  },
                }
                }}
              >
                {checkEventPermission("API_TOKEN_ACTIVATE") && 
                <MenuItem onClick={() => handleactivatedeactivate(row.id, row.isActive, row.tokenName)}>
                 <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem>
       }
       {checkEventPermission("API_TOKEN_DELETE") && 
                <MenuItem onClick={() => handleDeleteApiToken(row.id, row.tokenName)}>
                <span style={{ paddingLeft: '15px', color: '#F13139' }}>Delete</span>
                </MenuItem>
      }
              </Menu>
            </div>
      }
          </div>
        )
      },
      width: '10%',
      sortable: false,
      // style: { left: '0'}
      center: true,
    },

  ]

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage API Key</h2>
      <div className="mt-[20px] mb-[20px] live-outreach-container">
        <Grid container spacing={2} alignItems={'center'}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <div className="w-full">
              <input
                type="text"
                placeholder="Search by name"
                className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                onChange={handleSearch}
              />
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={8} className='bulk-action flex justify-end'>
            {checkEventPermission("API_TOKEN_ADD") &&
              <GradientButton color='red' onClick={() => handleAddApiToken(1, '1', 1)}>
                <span style={{
                  width: "20px",
                  height: "20px",
                  background: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50px",
                  marginRight: "5px"
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                    <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                  </svg>
                </span>
                Add New API Key
              </GradientButton>
            }
          </Grid>
        </Grid>
      </div>
      
      <div className='data-table-container mb-10 te-table-container'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={apiTokenSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

      <BootstrapDialog onClose={handleAddApiTokenClose} aria-labelledby="customized-dialog-title" open={showAddApiModal} PaperProps={{ sx: { width: '550px', height: '200px'},}}>
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          New API Key
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleAddApiTokenClose} sx={{ position: 'absolute', right: 8,top: 8,color: (theme) => theme.palette.grey[500],}}>
       <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            /> 
        </IconButton>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            label="Enter API Key Name*"
            value={tokenName}
            onChange={(e) => {
              setTokenName(e.target.value);
              setValidationError(''); // Clear the error when user types
            }}
            error={!(validationError.length === 0)} // Highlight the field in red if there's an error
            autoFocus
          />
          {(validationError.length > 0) && (
              <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                  <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                  {validationError} {/* Show the error message */}
              </div>
          )}
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color='gray' onClick={handleAddApiTokenClose} width='100px'>Close</OutlineButton>
          <GradientButton type='button' color='red' onClick={handleAddApiTokenConfirm} width='150px'>{!isModalSaveLoading ? 'Generate API Key' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleDeleteApiTokenClose}
        aria-labelledby="customized-dialog-title"
        open={showDeleteApiTokenModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Delete API Key
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleDeleteApiTokenClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_API} <span className='font-semibold'>{apiTokenInfoData?.apiTokenName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color='gray' onClick={handleDeleteApiTokenClose} width='100px'>Cancel</OutlineButton>
          <GradientButton type='button' color='red' onClick={handleDeleteApiTokenConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleactivatedeactivateClose}
        aria-labelledby="customized-dialog-title"
        open={showDeactivateApiModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          {(Boolean((apiTokenInfoData?.isActive))) ? "Activate API Key" : "Deactivate API Key"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleactivatedeactivateClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
           <HugeiconsIcon
              icon={MultiplicationSignStrokeStandard}
              size={24}
              color="currentcolor"
              strokeWidth={0.5}
            /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {(Boolean((apiTokenInfoData?.isActive))) ? "activate the API Key" : "deactivate the API Key"} <span className='font-semibold'>{apiTokenInfoData?.clientName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>
          <OutlineButton color='gray' onClick={handleactivatedeactivateClose} width='130px'>Cancel</OutlineButton>
          <GradientButton type='button' color='red' onClick={handleActivateDeactivateConfirm} width='130px'>{!isModalSaveLoading ? ((Boolean((apiTokenInfoData?.isActive))) ? "Activate" : "Deactivate") : (<span className="loading loading-spinner loading-xs text-white"></span>)}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      </div>
    </>
  );
};


export default ApiTokenList;

